// extracted by mini-css-extract-plugin
module.exports = {"DashboardBase__MainContent":"DashboardBase_DashboardBase__MainContent__2ojff"};